export default "__VITE_ASSET__BdXBCk6K__"